$(function () {
  var windowWidth = $(window).width()

  $('.footerheading').on('click', function (e) {
    e.preventDefault()
    windowWidth = $(window).width()
    if (windowWidth <= 991) {
      var $this = $(this)
      $this.toggleClass('chevron_close chevron_open')
      var $list = $this.next()
      $list.slideToggle()

    }
  })

  $(window).on('resize', function (event) {
    // console.log(windowWidth)
    windowWidth = $(window).width();
    if (windowWidth > 991) {
      $('ul.chevronlist').removeAttr("style");
      $('.footerheading').removeClass('chevron_open');
      $('.footerheading').addClass('chevron_close');
    }
  })
});